import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import heroImg from "../../assets/images/HeroSection/heroImg.png";

export const HeroSection = () => {
  return (
    <section className="bg-light py-5 px-1">
      <div className="position-relative d-flex align-items-center justify-content-end">
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <h5 className="text-primary">Welcome to Lumnis</h5>
              <h2 className="text-black">
                Democratizing{" "}
                <span className="text-primary">Investment Insights</span>
              </h2>
              <p>
                A research platform geared towards empowering cryptocurrency
                traders to make better investment decisions by providing them
                with data-driven insights.
              </p>
              <div className="d-flex flex-wrap align-items-center">
                <Link to="/">
                  <Button variant="primary" className="btn-lg mr-4">
                    Get Started
                  </Button>
                </Link>
                <Link to="/" className="text-primary text-decoration-none">
                  See How it Works
                </Link>
              </div>
            </Col>
            <Col lg="6">
              <div className="text-center">
                <img
                  src={heroImg}
                  alt="Hero Img"
                  className="img-fluid"
                  width="100%"
                  height="auto"
                />
              </div>
            </Col>
          </Row>
        </Container>
        <div className="position-absolute d-none d-xl-block">
          <img src={heroImg} alt="Hero Img" className="img-fluid" />
        </div>
      </div>
    </section>
  );
};
